import { QuantityField } from '@flos/react-ui';
import { useState } from 'react';
import { type AttributeChangeProps } from '../../../types';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import _ from 'lodash';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const delayMs = 500;

const HouseToiletChange = ({
    updateCoverableAttribute,
    additionalProps
}: AttributeChangeProps): React.JSX.Element => {
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.prhHouse
        ?.toiletsNumber;
    const [quantity, setQuantity] = useState<number>(currentOPCAttribute ?? 0);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const handleChange = (value: number): void => {
        setQuantity(value);
        updateCoverableAttribute({ toiletsNumber: value });
        setIsOpcDataFilled(true);
    };
    if (isOpcFetching) return <></>;
    return (
        <QuantityField
            defaultValue={quantity}
            onChange={_.debounce(handleChange, delayMs, { leading: false, trailing: true })}
        />
    );
};

export default HouseToiletChange;
